<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * Component displays step progress in a form of dots.
     * Simplified progress display to be used in lite mode
     */

    /**
     * @typedef {Object} Props
     * @property {Number} total
     * @property {Number} [currentPosition]
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        total,
        currentPosition = 0
    } = $props();
</script>

<style>
    ol {
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: inline-flex;
        align-items: flex-start;
        justify-content: center;

        & li {
            display: flex;
            height: 3rem;
            width: 3rem;
            border: 0.25rem solid var(--color-text-default);
            border-radius: var(--radius-circular);
            margin: 0.75rem;
            background-color: var(--color-bg-default);

            &.viewed {
                background-color: var(--color-text-default);
            }
        }
    }
</style>

{#if total}
    <div>
        <span class="visually-hidden">{__('Question %d of %d', 1 + currentPosition, total)}</span>
        <ol class="dots">
            <!-- eslint-disable-next-line no-unused-vars -->
            {#each Array(total) as val, i (`${total}-${i}`)}
                <li class:viewed={i <= currentPosition}></li>
            {/each}
        </ol>
    </div>
{/if}
